export default {
  namespaced: true,
  state: {
    api: {},
    name: null,
    expires_at: null,
    category: null,
    agent: null,
    id: null,
  },
  mutations: {
    SET_ITEM(state, data) {
      state[data[0]] = data[1];
    },
  },
  actions: {
    VALIDATE_TASK({ dispatch, state }, route) {
      if (
        state.name
        && state.agent
        && state.category
        && state.expires_at
      ) {
        dispatch('CREATE_TASK', route);
      } else {
        this._vm.$notify({
          group: 'foo',
          type: 'error',
          title: 'Wichtige Mitteilung',
          text: 'Nicht alle Pflichtfelder ausgefüllt.',
        });
      }
    },
    async CREATE_TASK({ commit, state }, route) {
      try {
        const response = await axios.post(route, {
          name: state.name,
          agent_user_id: state.agent.id,
          category: state.category.id,
          expires_at: state.expires_at,
          id: state.id,
        });
        window.location.href = state.api.task_index;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
